import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchBuyers } from "../features/buyers/buyerSlice";

import BuyerForm from "./BuyerForm";
import BuyerTable from "./BuyerTable";

function Buyers() {

    const dispatch = useDispatch();

    const { loading, error } = useSelector(
        (state) => state.buyers
    );

    useEffect(() => {

        dispatch(fetchBuyers());

    }, [dispatch]);

    if (loading) {

        return (

            <div className="text-center mt-5">

                <div className="spinner-border text-primary"></div>

            </div>

        );

    }

    if (error) {

        return (

            <div className="alert alert-danger">

                {error}

            </div>

        );

    }

    return (

        <div className="container-fluid mt-3">

            <div className="row">

                <div className="col-lg-4">

                    <BuyerForm />

                </div>

                <div className="col-lg-8">

                    <BuyerTable />

                </div>

            </div>

        </div>

    );

}

export default Buyers;